import styled from 'styled-components';
import { Space } from 'antd';

export const ListContainer = styled(Space)`
  margin: 0 auto;
  width: 100%;
  max-width: 1152px;
  padding: 0 24px;
`;
